import {useEntityChannels} from '../../../hooks/useEntityChannels'

export const useUserChannels = (userId?: string | number) => useEntityChannels('user', userId)
